// extracted by mini-css-extract-plugin
export default {"logo":"top-nav_logo__YH0Od","logoContainer":"top-nav_logoContainer__dV+bd","content":"top-nav_content__5Y4o3","nav":"top-nav_nav__0+-LO","scrolled":"top-nav_scrolled__I55bY"};